import Vue from 'vue'
import App from './App.vue'
import './assets/css/mdui.css' // 注意修改 css 文件的路径
import store from './store/index'
import { jsonp  } from './tool/jsonp'
import message from './tool/message'
import httpService from './tool/httpService'




Vue.config.productionTip = false;
// step2：把axios挂载到vue的原型中，在vue中每个组件都可以使用axios发送请求,
// 不需要每次都 import一下 axios了，直接使用 $axios 即可
//Vue.prototype.$axios = Axios
// 扩充
declare module 'vue/types/vue' {
  interface Vue {
    $axios: any;
  }
}

// // 调用登录弹窗的共通     TODO 删除
// function loginDialog(flag:number){
//   if(store.state.loginFlag == flag){
//     // 如果数字没变化强行变化一次 TODO 为什么这里能直接赋值呢
//     store.state.loginFlag = 9;
//     console.log(flag);
//     setTimeout(() => {
//       store.state.loginFlag = flag;     
//     }, 10);
//   } else {
//     store.state.loginFlag = flag;
//   }
  
// }



Vue.prototype.$httpService = new httpService(store);  // 挂载服务
Vue.prototype.$jsonp = jsonp;
Vue.prototype.$msgbox = message;

new Vue({
  store,
  render: h => h(App)
}).$mount('#app')


//判断是否是ie
function isIE() {
  // @ts-ignore
  return !!window.document.documentMode;
}


//F12提示信息
if (window.top === window && window.console && !isIE()) {
  setTimeout(() => {
    window.console.log('%c%s', 'color: red; background: yellow; font-size: 24px;', '警告！');
    window.console.log('%c%s', 'color: black; font-size: 18px;', `使用此控制台可能会让攻击者利用 Self-XSS（自跨站脚本）攻击来冒充你，并窃取你的信息。
请勿输入或粘贴你不明白的代码。`);
    window.console.log('本站ui框架采用mdui')
  });
}

// store.commit('setAction','aaaaaa');


